import { create } from 'zustand';
import type { Workspace } from '@/types';

interface WorkspaceSwitchState {
  /** The workspace being switched INTO, or null when not switching. */
  target: Workspace | null;
  begin: (workspace: Workspace) => void;
  end: () => void;
}

/**
 * Where the switch-in-progress lives, because the two halves are in different
 * parts of the tree.
 *
 * The switcher sits in the SIDEBAR and the overlay must cover the CONTENT AREA
 * only — the sidebar stays visible and is already showing the target, which is
 * the single most reassuring thing on the screen while the token is swapped.
 * The first version rendered the overlay next to the trigger and covered the
 * whole viewport, hiding the one element that told the merchant it was working.
 *
 * A store rather than a context: the Workspaces page can start a switch too,
 * and both callers need the same overlay without the layout knowing who asked.
 */
export const useWorkspaceSwitchStore = create<WorkspaceSwitchState>((set) => ({
  target: null,
  begin: (workspace) => set({ target: workspace }),
  end: () => set({ target: null }),
}));
